import { getActiveInteraction } from '../interaction-metrics';
import getElementName from '../vc/vc-observer-new/get-unique-element-name';
let performanceEventObserver;
const selectorConfig = {
  id: true,
  testId: true,
  role: true,
  className: true
};
function getTestIdName(memoizedProps) {
  if (memoizedProps['data-testid']) {
    return `[data-testid=${memoizedProps['data-testid']}]`;
  } else if (memoizedProps['data-test-id']) {
    return `[data-test-id=${memoizedProps['data-testid']}]`;
  }
  return null;
}
function getUFOSegmentName(componentName, memoizedProps) {
  if (memoizedProps && memoizedProps['name']) {
    return `UFOSegment[name=${memoizedProps['name']}]`;
  }
  return componentName;
}
function getReactComponentHierarchy(element) {
  const componentHierarchy = [];
  // Function to traverse up the fiber tree
  function traverseFiber(fiber) {
    let currentFiber = fiber;
    while (currentFiber) {
      if (currentFiber.type) {
        // Check if there's a display name or a function name
        const componentName = currentFiber.type.displayName || currentFiber.type.name;
        // checking when component name is bigger than the minimized name produced by react
        if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
          if (componentName === 'UFOSegment') {
            componentHierarchy.push(getUFOSegmentName(componentName, currentFiber.memoizedProps));
            break;
          }
          componentHierarchy.push(componentName);
        }
      }
      if (currentFiber.memoizedProps) {
        const dataIdInfo = getTestIdName(currentFiber.memoizedProps);
        if (dataIdInfo) {
          componentHierarchy.push(dataIdInfo);
          currentFiber = null;
          continue;
        }
      }
      currentFiber = currentFiber.return;
    }
  }
  // Access the reactFiber node from the HTML element
  const reactFiberKey = Object.keys(element).find(key => key.startsWith('__reactFiber$'));
  if (reactFiberKey) {
    const fiber = element[reactFiberKey];
    traverseFiber(fiber);
  }
  return componentHierarchy.reverse().join(' > ');
}
export const getPerformanceObserver = () => {
  performanceEventObserver = performanceEventObserver || new PerformanceObserver(entries => {
    const list = entries.getEntries();
    for (let entry of list) {
      if (entry.name === 'click') {
        setInteractionPerformanceEvent(entry);
      }
    }
  });
  return performanceEventObserver;
};
export const setInteractionPerformanceEvent = entry => {
  const interaction = getActiveInteraction();
  if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
    var _interaction$responsi;
    if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
      var _interaction$responsi2, _interaction$responsi3;
      interaction.responsiveness = {
        ...interaction.responsiveness,
        experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
        inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
      };
      if (interaction.ufoName === 'unknown') {
        if (entry.target) {
          const componentHierarchy = getReactComponentHierarchy(entry.target);
          interaction.unknownElementHierarchy = componentHierarchy;
        }
        interaction.unknownElementName = getElementName(selectorConfig, entry.target);
      }
    }
  }
};